import { Command } from 'ckeditor5/src/core';
import MgnlLink from './mgnllink';

/**
 * The mgnl link command.
 */
export class MgnlLinkCommand extends Command {
	public static COMMAND_NAME = 'createMgnlLink';
	public override refresh(): void {
		super.refresh();
		const { document, schema } = this.editor.model;

		// check if the selected text has the attribute 'mgnlLink'
		this.value = document.selection.getAttribute( MgnlLink.MGNL_LINK_ATTRIBUTE );

		// check if command is allowed on current selection
		this.isEnabled = schema.checkAttributeInSelection( document.selection, MgnlLink.MGNL_LINK_ATTRIBUTE );
	}

	public override execute( data: string ): void {
		super.execute();
		const model = this.editor.model;
		const selection = model.document.selection;
		const link = JSON.parse( data );

		let href: string;

		// Check if this is a DAM asset link
		if ( link.repository === 'dam' && link.identifier && link.path ) {
			// For DAM assets, use the same URL format as MgnlImageInsert
			const origin = window.location.origin;
			const pathParts = link.path.split( '/' );
			const fileName = pathParts[ pathParts.length - 1 ];
			href = `${ origin }/dam/jcr:${ link.identifier }/${ fileName }`;
			console.log( 'Generated DAM asset URL:', href );
		} else {
			// For non-DAM links (pages, etc.), use the original Magnolia link format
			href = '${link:{uuid:{' + link.identifier +
				'},repository:{' + link.repository +
				'},path:{' + link.path +
				'}}}';
		}

		model.change( writer => {
			if ( !selection.isCollapsed ) {
				const ranges = model.schema.getValidRanges( selection.getRanges(), MgnlLink.MGNL_LINK_ATTRIBUTE );
				for ( const range of ranges ) {
					writer.setAttribute( MgnlLink.MGNL_LINK_ATTRIBUTE, href, range );
					writer.setAttribute( 'linkHref', href, range );
				}
			} else {
				const caption = writer.createText( link.caption, {
					mgnlLink: href,
					linkHref: href
				} );
				model.insertContent( caption, selection.getFirstPosition() );
			}
		} );
	}
}
